import Flickity from 'flickity'

const enableOnTouchMove = () => {
    if (!window.ontouchmoveIsEnabled) document.ontouchmove = () => true
    window.ontouchmoveIsEnabled = true
}
  
const disableOnTouchMove = () => {
    if (window.ontouchmoveIsEnabled) document.ontouchmove = () => false
    window.ontouchmoveIsEnabled = false
}
export default class extends Flickity {
  constructor (...args) {
    super(...args)
    this.on('settle', (e, idx) => {
      if (this.resizeQueued) {
        this.resizeQueued = false
        this.resize()
      }
    })
    if (document.ontouchmove === null) disableOnTouchMove()
    this.on('dragStart', disableOnTouchMove)
    this.on('dragEnd', enableOnTouchMove)
  }

  resize () {
    if (this.isAnimating) {
      this.resizeQueued = true
      return
    }
    super.resize()
  }
}
